import FurnishingRefundForm from "./furnishing-refund-form";

import "./furnishing-forms.scss";


const FurnishingForms = {
    Refund : FurnishingRefundForm
}

export default FurnishingForms;